export const refundsSx = {
    dialogPaper: {
        width: '400px',
        maxWidth: '90%',
        borderRadius: 3,
        p: 2,
        backgroundColor: '#fff',
    },
    dialogTitle: { fontWeight: 'bold' },
    dialogContentBox: { py: 1 },
    dialogActions: { justifyContent: 'flex-end' },
    closeButton: { borderRadius: 2 },
    table: { minWidth: 650 },
    tableHeadCell: { fontSize: 18, fontWeight: 'bold', py: 2 },
    tableHeadCellPrice: { fontSize: 18, fontWeight: 'bold', minWidth: '150px' },
    tableRowCell: { fontSize: 16, fontWeight: 600, py: 2, maxWidth: 300 },
    courseBox: { display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 },
    iconBox: { width: 24, height: 24, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    courseTitle: {
        color: 'secondary',
        textDecoration: 'none',
        cursor: 'pointer',
        fontWeight: 'inherit',
        fontSize: 'inherit',
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flexGrow: 1,
        minWidth: 0
    }
};
